export default __webpack_public_path__ + "static/media/icon-multichain.d28d7f6b.svg";